export default [
	{
		path: '/aids',
		name: 'aids',
		component: () => import('@/views/Aid/Aids.vue'),
		meta: { requiresAuth: true, permission: 'view_aids' }
	},
	{
		path: '/aids/create',
		name: 'aids.create',
		component: () => import('@/views/Aid/CreateAid.vue'),
		meta: { requiresAuth: true, permission: 'create_aid' }
	},
	{
		path: '/aids/:id',
		props: true,
		component: () => import('@/views/Aid/Aid.vue'),
		meta: { requiresAuth: true, permission: 'view_aid' }
	}
]
